import {List, Map} from 'immutable'
import {useState} from 'react'
import PropTypes from 'prop-types'

import DashboardHeading from '../../../../../shared_components/mui_base_components/dashboard_heading/DashboardHeading'
import ItemWithResponsesBox from './ItemWithResponsesBox'
import AddDeputyModal from '../../corp_max_deputies/add/AddDeputyModal'
import PrearrangedFuneralCard from '../../../../../shared_components/PrearrangedFuneralCard'

import {useDeputyData} from '../../../../../lib/hooks'
import {itemResponsesWithResponseGroupMap} from '../../../../../lib/plan_data/itemResponsesHelper'

const ItemsWithResponses = props => {
  const [showAddDeputyModal, setShowAddDeputyModal] = useState(false)
  const [contactToAddAsDeputy, setContactToAddAsDeputy] = useState(Map())

  const {deputies} = useDeputyData(props.userConfig.get('everplan-id'))

  const itemResponses = itemResponsesWithResponseGroupMap(props.categoryItemResponses)

  const openAddDeputyModal = (contact = Map()) => {
    setContactToAddAsDeputy(contact)
    setShowAddDeputyModal(true)
  }

  const closeAddDeputyModal = () => {
    setContactToAddAsDeputy(Map())
    setShowAddDeputyModal(false)
  }

  if (itemResponses.isEmpty()) {
    return null
  } else {
    return (
      <div className='items-with-responses'>
        <DashboardHeading>In your Everplan</DashboardHeading>
        {props.showPrearrangedFuneralCard && (
          <PrearrangedFuneralCard showConfirmationMessage />
        )}
        {
          itemResponses
            .map(itemResponse =>
              (
                <ItemWithResponsesBox
                  {...props}
                  openAddDeputyModal={openAddDeputyModal}
                  itemResponse={itemResponse}
                  key={itemResponse.get('id')}
                />
              )
            )
        }
        {
          showAddDeputyModal && (
            <AddDeputyModal
              {...props}
              deputies={deputies}
              exit={closeAddDeputyModal}
              selectedContact={contactToAddAsDeputy}
              source={contactToAddAsDeputy.isEmpty() ? null : 'suggested'}
            />
          )
        }

      </div>
    )
  }
}

ItemsWithResponses.propTypes = {
  categoryItemResponses: PropTypes.instanceOf(List),
  userConfig: PropTypes.instanceOf(Map),
  showPrearrangedFuneralCard: PropTypes.bool
}

export default ItemsWithResponses
